module.exports = __webpack_public_path__ + "assets/img/mecha-607ae48c.png";